import { Button } from '@material-ui/core';
import Sync from '@material-ui/icons/Sync';
import React from 'react';
import useStyles from '../../styles/useStyles';

export const ForceSyncButton: React.FC<any> = ({ props, setDataItemForDelete, setVisible, visible }) => {
    const classes = useStyles();
    return (

        <div className={`${classes.root} ${classes.buttonGridAction}`} title="Sync Asite-Relatics">
            <Button
                variant='contained'
                size='small'
                className={classes.deleteButton}
                onClick={(e) => {
                    setDataItemForDelete(props.dataItem);
                    setVisible(!visible);
                }}
                style={{ backgroundColor: '#8dd9c8', color: 'white' }}
            >
                <Sync className={classes.deleteButtonIcon} />
            </Button>
        </div>
    );
};